module.exports = __webpack_public_path__ + "static/media/crostacei.dbe540d3.svg";